import datapoints from './../datapoints';
import FindLocationResultState from '../data/schema/FindLocationResultState';
import showHideFindResult from './showHideFindResult';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { LocationPersonaControlViewState } from 'owa-location-persona';
import { trace } from 'owa-trace';

/**
 * Action to resolve the selected location
 * @param findLocationResultState: the find location dropdown state
 * @param newLocation: the new persona to add or a location name string
 */
export default createLegacyActionWithDatapoint(
    'resolveSelectedLocation',
    datapoints.resolveSelectedLocation
)(function resolveSelectedLocation(
    findLocationResultState: FindLocationResultState,
    newLocation: LocationPersonaControlViewState | string
) {
    if (findLocationResultState && findLocationResultState.addLocationHandler) {
        findLocationResultState.addLocationHandler(newLocation);
    } else {
        trace.error(
            'resolveSelectedLocation: findLocationResultState and addLocationHandler should be set'
        );
    }

    showHideFindResult(
        findLocationResultState,
        false /* shouldShowFindResult */,
        true /* shouldClearFindResult */
    );
});
